import { render, staticRenderFns } from "./QuestionnaireList.vue?vue&type=template&id=6433c4b3&scoped=true&lang=pug"
import script from "./QuestionnaireList.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireList.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireList.vue?vue&type=style&index=0&id=6433c4b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6433c4b3",
  null
  
)

export default component.exports